module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "epub:type": "pagebreak",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0007#ch01"
    }
  }, [_vm._v("Hit or Miss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0008#ch02"
    }
  }, [_vm._v("A Perfect Day at Riis Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0009#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fortunetellers in Williamsburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0010#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lightning Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0011#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Those Delusions of Grandeur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0012#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0013#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People from Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0014#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lies and Funerals, Complexications")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0015#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0016#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rancho Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0017#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safe Places")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0018#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Falling Off the George Washington Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaDOLAN0019#acknow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80ef7b48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/umaDOLAN0005.vue
// module id = 69
// module chunks = 0